<template>
    <div>
        <section class="section hero-section bg-ico-home-1 p-3">
            <div class="container">
                <div class="row align-items-center" data-aos="fade-up">
                    <div class="col-md-12 ml-auto">
                        <div class="mt-4 mt-md-auto">
                            <img src="awan/images/object-6.webp" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section" style="background-color: #233dff;">
            <div class="row align-items-center" data-aos="fade-up">
                    <div class="col-md-12 ml-auto">
                        <div class="mt-4 mt-md-auto">
                            <img src="awan/images/object-5.webp" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'Produk',
    components: {
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
        document.title = 'Produk PPOB Awanbisnis'
        this.$Progress.start()
        AOS.init({
            easing: 'ease-out-back',
            duration: 2000,
        });
        this.$Progress.finish()
    },
}
</script>